import { render } from "./ContentIoT.vue?vue&type=template&id=5be4ecc3&scoped=true&ts=true"
import script from "./ContentIoT.vue?vue&type=script&lang=ts"
export * from "./ContentIoT.vue?vue&type=script&lang=ts"

import "./ContentIoT.vue?vue&type=style&index=0&id=5be4ecc3&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be4ecc3"]])

export default __exports__